import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const stateSelector = ({
  layout: { controller, url, deviceType: { isMobile }, pageId },
  accordion: { expandedNodeId, breadCrumbClicked },
  legislation: { actIdMap },
  placeholders: { isAccordionLoaded }
}: RootState): { url: RootState['layout']['url'], controller: RootState['layout']['controller'], expandedNodeId: RootState['accordion']['expandedNodeId'], breadCrumbClicked: RootState['accordion']['breadCrumbClicked'], isMobile: boolean, actIdMap: RootState['legislation']['actIdMap'], pageId: RootState['layout']['pageId'], isAccordionLoaded: RootState['placeholders']['isAccordionLoaded'] } => ({ url, controller, expandedNodeId, breadCrumbClicked, isMobile, actIdMap, pageId, isAccordionLoaded })

const selectAccordionFoundState = createSelector(stateSelector, (state): ReturnType<typeof stateSelector> => state)

export default selectAccordionFoundState
